import { Button, Input, Label, Textarea } from "@repo/ui";
import { useState } from "react";

import { Footer } from "@/components/footer";
import { Nav } from "@/components/nav";

export function Contact() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setStatus("loading");
    const form = new FormData(e.currentTarget);
    const payload = Object.fromEntries(form.entries());
    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error("Failed");
      setStatus("success");
      (e.currentTarget as HTMLFormElement).reset();
    } catch {
      setStatus("error");
    }
  }
  return (
    <div className="min-h-screen flex flex-col">
      <Nav />
      <section className="mx-auto max-w-xl px-4 md:px-6 py-12">
        <h1 className="text-3xl md:text-4xl font-semibold mb-6">Contact</h1>
        <p className="text-foreground/70 mb-8">
          Looking to collaborate or hire Jenn? Send a message below.
        </p>
        <form onSubmit={onSubmit} className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="name">Name</Label>
            <Input id="name" name="name" required placeholder="Your name" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" name="email" type="email" required placeholder="you@example.com" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="message">Message</Label>
            <Textarea
              id="message"
              name="message"
              required
              placeholder="How can Jenn help?"
              rows={6}
            />
          </div>
          <Button type="submit" disabled={status === "loading"} className="h-10 px-6">
            {status === "loading" ? "Sending..." : "Send message"}
          </Button>
          {status === "success" && (
            <p className="text-sm text-green-400">Thanks! Your message has been sent.</p>
          )}
          {status === "error" && (
            <p className="text-sm text-red-400">
              Something went wrong. Please try again later or email jenn@stardeck.ai.
            </p>
          )}
        </form>
      </section>
      <Footer />
    </div>
  );
}
